<app-mobile-header-secondary title="{{ 'menu.notification' | translate }}"></app-mobile-header-secondary>

<article class="configuration-item">
  <div class="configuration-container d-none d-lg-block">
    <div class="configuration-content">
      <p class="configuration-title">{{ 'menu.notification' | translate }}</p>
    </div>
  </div>
  <div class="configuration-container">
    @if (notificationForm) {
      <form class="form" [formGroup]="notificationForm" (ngSubmit)="updateNotificationsInfo()" novalidate>
        <div formGroupName="notification">
          <div class="configuration-switches-item">
            <app-switch formControlName="signature_others" (change)="updateNotificationsInfo()"></app-switch>
            <span class="configuration-switches-name fw400">{{ 'settings.receiveNotificationEmailWhen.documentSignedBySignatories' | translate }}</span>
          </div>
          <div class="configuration-switches-item">
            <app-switch formControlName="signature_you" (change)="updateNotificationsInfo()"></app-switch>
            <span class="configuration-switches-name fw400">{{ 'settings.receiveNotificationEmailWhen.youSignTheDocument' | translate }}</span>
          </div>
          <div class="configuration-switches-item">
            <app-switch formControlName="signature_approval" (change)="updateNotificationsInfo()"></app-switch>
            <span class="configuration-switches-name fw400">{{ 'settings.receiveNotificationEmailWhen.signatureApproval' | translate }}</span>
          </div>
        </div>
      </form>
    }
  </div>
</article>
